export default __webpack_public_path__ + "static/media/pic7.51b3c4ce.jpg";